import { useState } from "react";
import { Bell, AlertCircle, Clock, Video } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

const STATIC_ALERT = {
  id: "alert-glasses-1",
  title: "Aavyaa just removed her glasses",
  description: "Detected during playroom activity. This is her 3rd removal today.",
  timestamp: "Today · 2:47 PM",
  severity: "moderate",
  clip_url: "https://aavaa1510.s3.eu-north-1.amazonaws.com/clip1.mp4",
};

export default function AlertsTab() {
  const [openAlert, setOpenAlert] = useState(null);

  return (
    <div className="p-4 pt-6" data-testid="alerts-tab">
      <div className="flex items-center gap-2 mb-1">
        <Bell size={22} className="text-[#D4A373]" strokeWidth={1.5} />
        <h1 className="font-outfit text-3xl font-medium text-[#2F3630] tracking-tight">Alerts</h1>
      </div>
      <p className="font-manrope text-sm text-[#6B7264] mb-6">
        Moments Aavaa flagged for your attention today.
      </p>

      {/* Alert card */}
      <button
        data-testid="alert-card"
        onClick={() => setOpenAlert(STATIC_ALERT)}
        className="w-full text-left bg-white rounded-[20px] p-4 border border-[#D4A373]/40 shadow-[0_6px_20px_-10px_rgba(212,163,115,0.35)] hover:shadow-[0_10px_30px_-10px_rgba(212,163,115,0.45)] transition-all animate-fade-up"
      >
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#D4A373]/15 flex items-center justify-center flex-shrink-0">
            <AlertCircle size={18} className="text-[#D4A373]" strokeWidth={2} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between gap-2 mb-1">
              <h3 className="font-outfit text-base font-medium text-[#2F3630] truncate">
                {STATIC_ALERT.title}
              </h3>
              <span className="flex-shrink-0 text-[10px] font-manrope uppercase tracking-wider bg-[#D4A373]/15 text-[#B8864F] rounded-full px-2 py-0.5">
                New
              </span>
            </div>
            <p className="font-manrope text-xs text-[#6B7264] leading-relaxed mb-2">
              {STATIC_ALERT.description}
            </p>
            <div className="flex items-center gap-3 text-[11px] font-manrope text-[#6B7264]/80">
              <span className="flex items-center gap-1"><Clock size={11} /> {STATIC_ALERT.timestamp}</span>
              <span className="flex items-center gap-1"><Video size={11} /> Tap to view clip</span>
            </div>
          </div>
        </div>
      </button>

      {/* Empty state below */}
      <p className="text-center text-xs font-manrope text-[#6B7264]/60 mt-8">
        You'll see more alerts here as Aavaa notices things worth your attention.
      </p>

      {/* Clip viewer */}
      <Dialog open={!!openAlert} onOpenChange={() => setOpenAlert(null)}>
        <DialogContent className="max-w-lg p-0 rounded-2xl overflow-hidden bg-black">
          {openAlert && (
            <div>
              <video
                src={openAlert.clip_url}
                controls
                autoPlay
                className="w-full max-h-[70vh]"
                data-testid="alert-video-player"
              />
              <div className="bg-white p-4">
                <p className="font-outfit text-sm font-medium text-[#2F3630]">{openAlert.title}</p>
                <p className="font-manrope text-xs text-[#6B7264] mt-0.5">{openAlert.timestamp}</p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
